<template>
  <div class="col-md-12">
    <div class="form-group">
      <input type="text" class="form-control" v-model="search" placeholder="Search">
    </div>
    <p align="left">
      <button class="btn btn-warning" @click="addproduct">Add Product</button>
    </p>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover" style="width:100%">
          <thead width="400px">
              <tr class="thead-light">
                  <!--<th colspan="2">Action</th>-->
                  <th scope="col" class="col-xs-2 col-md-2">Product</th>
                  <th scope="col" class="col-xs-2 col-md-2">Special Offer?</th>
                  <th scope="col" class="col-xs-2 col-md-2" @click="sort('category')">Category <i class="fas fa-sort-alpha-down float-right"></i></th>
                  <th scope="col" class="col-xs-2 col-md-2" @click="sort('name')">Name<i class="fas fa-sort-alpha-down float-right"></i></th>
                  <th scope="col" class="col-xs-2 col-md-2">Description</th>
                  <th scope="col" class="col-xs-2 col-md-2">Currency</th>
                  <th scope="col" class="col-xs-2 col-md-2">Price</th>
                  <th scope="col" class="col-xs-2 col-md-2">Discount</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(list, index) in (sortedActivity, filteredList)" :key="list['.name']">
                <!--<td><router-link :to="{ name: 'Editproductitem', params: {id: list.name} }" class="btn btn-warning">
                    Edit
                  </router-link>
                </td>
                <td><button class="btn btn-danger">Delete</button></td>-->
                <td><font color="#000000"><img :src="list.photo" width="150" height="100"></font></td>
                <td>
                  <input type="checkbox" v-if = "list.special" checked disabled>
                  <input type="checkbox" v-else disabled>
                </td>
                <td><font color="#000000">{{list.category}}</font></td>
                <td><font color="#000000">{{list.name}}</font></td>
                <td><font color="#000000">{{list.descr}}</font></td>
                <td><font color="#000000">{{list.currency}}</font></td>
                <td><font color="#000000">{{list.price}}</font></td>
                <td><font color="#000000">{{list.discount}}</font></td>
              </tr>
          </tbody>
      </table>
    </div>
 <button @click="prevPage" class="float-left btn btn-outline-info btn-sm"><i class="fas fa-arrow-left"></i> Previous</button> 
 <button @click="nextPage" class="float-right btn btn-outline-info btn-sm">Next <i class="fas fa-arrow-right"></i></button>
  </div>
</template>

<script>
/*eslint-disable*/
import firebase from 'firebase'
import {db} from '../main'

export default {
  name: 'viewlistproduct',
  data: () => ({
    users: [],
    currentSort:'name',
    currentSortDir:'asc',
    search: '',
    searchSelection: '',
    pageSize: 5,
    currentPage: 1,
    lists: []
  }),
  firestore () {
    return {lists: db.collection('products')
    }

  },
  methods:{
    addproduct: function(){
          this.$router.push('/addproduct  ') 
    },
    sort:function(s) {
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
    },
    nextPage:function() {
      if((this.currentPage*this.pageSize) < this.lists.length) this.currentPage++;
    },
    prevPage:function() {
      if(this.currentPage > 1) this.currentPage--;
    }
  },

  computed: {
    sortedActivity:function() {
      return this.lists.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    },

    filteredList () {
      return this.lists.filter((data) => {
        //alert('Search: ' + this.search.toLowerCase() + ' data: ' + data.category.toLowerCase());
        let name = data.name.toLowerCase().match(this.search.toLowerCase());
        let category = data.category.toLowerCase().match(this.search.toLowerCase());
        let descr = data.descr.toLowerCase().match(this.search.toLowerCase());
        let currency = data.currency.toLowerCase().match(this.search.toLowerCase());
        //alert('Search: ' + this.search.toLowerCase() + ' result: ' + channel);
        return  name || category || descr || currency;
      }).filter((row, index) => {
        let start = (this.currentPage-1)*this.pageSize;
        let end = this.currentPage*this.pageSize;
        if(index >= start && index < end) return true;
      });
    }
  },

  created () {

  },

}
</script>

<style>
th {
  cursor:pointer;
  /* width: 500px !important; */
  white-space: nowrap;
}

tr {
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/components/viewlistproduct.vue